<template>

</template>

<script>
  import 'jquery-validation'
  import moment from 'moment'
  import 'flatpickr'
  import 'flatpickr/dist/flatpickr.min.css'
  import { Spanish } from 'flatpickr/dist/l10n/es'
  
  export default {
    name: 'RegisterProtocolAdvancePeriod',
    mounted () {
      const vm = this

      /**
       * Init FlatPickr
       */
      const $startDate = $('#start_date')
      const $endDate   = $('#end_date')
      
      $startDate.flatpickr({
        disableMobile: false,
        dateFormat: 'd/m/Y',
        locale: Spanish,
      })
      
      $endDate.flatpickr({
        disableMobile: false,
        dateFormat: 'd/m/Y',
        locale: Spanish,
      })

      this.starDate = $startDate.get(0)._flatpickr
      this.endDate  = $endDate.get(0)._flatpickr

      $.validator.addMethod('after', function (value, element, param) {
        const start = moment($(param).val(), 'DD/MM/YYYY').format('YYYY-MM-DD')
        const end   = moment(value, 'DD/MM/YYYY').format('YYYY-MM-DD')
        
        return $(param).val() !== '' && value !== '' && moment(end).isAfter(start)
      }, 'La fecha de término debe ser posterior a la fecha de inicio.')

      /**
       * Init JQuery validation
       */
      $(() => {
        $('.form').validate({
          ignore: [],
          highlight: function (element, errorClass, validClass) {
            $(element).addClass('is-invalid')
          },
          unhighlight: function (element, errorClass, validClass) {
            $(element).removeClass('is-invalid')
          },
          errorPlacement: function (label, element) {
            label.addClass('invalid-feedback')
            label.insertAfter(element)
          },
          rules: {
            period: {
              required: true,
            },
            year: {
              required: true,
            },
            start_date: {
              required: true,
            },
            end_date: {
              required: true,
              after: '#start_date',
            },
          },
          messages: {
            period: {
              required: 'Este campo es requerido.',
            },
            year: {
              required: 'Este campo es requerido.',
              min: 'Ingrese un numero mayor o igual a ' + new Date().getFullYear(),
            },
            start_date: {
              required: 'Este campo es requerido.',
            },
            end_date: {
              required: 'Este campo es requerido.',
            },
          },
          submitHandler (form) {
            $('#btn-save, #btn-cancel').prop('disabled', true)
            $('#btn-save').find('.spinner-border').removeClass('d-none')
            
            form.submit()
          },
        })
      })
    },
  }
</script>
